var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',{staticClass:"unique_cstm_tab"},[_c('vs-tab',{attrs:{"label":"Standard"}},[_c('div',{staticClass:"con-tab-ejemplo"},[_c('question-listing',{attrs:{"questionApplicationType":"General"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }